import { useEffect, useState } from 'react'
import { fetchRbacAssignedData } from '../services/rbacApi'
import {
  APP_USER_ASSIGNMENT_RESOURCES,
  hasValidAssignedData,
  hydrateAssignedData
} from '../utils/assignedData'

export default function useRbacUserDialog({
  mode,
  open,
  editTarget,
  form,
  errors,
  onFieldChange,
  onSubmit,
  onValidateBasicData,
  submitting
}) {
  const isEdit = mode === 'edit'
  const [step, setStep] = useState(0)
  const [assignmentError, setAssignmentError] = useState('')
  const [assignmentLoadError, setAssignmentLoadError] = useState('')
  const [assignmentAttempted, setAssignmentAttempted] = useState(false)
  const [assignmentLoading, setAssignmentLoading] = useState(false)
  const [assignmentValidating, setAssignmentValidating] = useState(false)
  const [assignmentLoadAttempt, setAssignmentLoadAttempt] = useState(0)
  useEffect(() => {
    if (open) {
      setStep(0)
      setAssignmentError('')
      setAssignmentLoadError('')
      setAssignmentAttempted(false)
    }
  }, [open])
  useEffect(() => {
    if (!isEdit || !open || !editTarget?.id) return
    let cancelled = false
    setAssignmentLoadError('')
    setAssignmentLoading(true)
    fetchRbacAssignedData(editTarget.id)
      .then((data) => {
        if (!cancelled) {
          const assignedData = hydrateAssignedData(data, APP_USER_ASSIGNMENT_RESOURCES)
          onFieldChange('assignedData', assignedData)
          onFieldChange('initialAssignedData', assignedData)
          setAssignmentLoading(false)
        }
      })
      .catch(() => {
        if (!cancelled) {
          setAssignmentLoadError('Revisa tu conexión e intenta de nuevo.')
          setAssignmentLoading(false)
        }
      })
    return () => {
      cancelled = true
    }
  }, [isEdit, open, editTarget?.id, assignmentLoadAttempt])
  useEffect(() => {
    if (Object.keys(errors || {}).some((field) => ['name', 'email', 'roleIds'].includes(field)))
      setStep(0)
  }, [errors])
  const validBasicData =
    form.name.trim() &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim()) &&
    form.roleIds.length > 0
  const assignmentBlocked =
    assignmentLoading || assignmentValidating || Boolean(assignmentLoadError)
  const saveOrNext = () => {
    if (submitting || ((isEdit || step === 1) && assignmentBlocked)) return
    if (step === 0) {
      if (!isEdit && onValidateBasicData && !onValidateBasicData()) return
      setStep(1)
      return
    }
    setAssignmentAttempted(true)
    if (!hasValidAssignedData(form.assignedData, APP_USER_ASSIGNMENT_RESOURCES)) {
      setAssignmentError('Seleccione una o más opciones por características.')
      return
    }
    setAssignmentError('')
    onSubmit()
  }
  const canEditEmail =
    !isEdit ||
    editTarget?.status === 'pending' ||
    (!editTarget?.active && editTarget?.email_verified === false)

  const retryAssignmentLoad = () => setAssignmentLoadAttempt((attempt) => attempt + 1)
  const changeAssignedData = (value) => {
    onFieldChange('assignedData', value)
    onFieldChange('assignedDataDirty', true)
    setAssignmentError('')
  }

  const primaryActionDisabled =
    ((isEdit || step === 1) && assignmentBlocked) || (isEdit && step === 0 && !validBasicData)

  return {
    isEdit,
    step,
    setStep,
    assignmentError,
    assignmentLoadError,
    assignmentAttempted,
    assignmentLoading,
    setAssignmentValidating,
    canEditEmail,
    saveOrNext,
    retryAssignmentLoad,
    changeAssignedData,
    primaryActionDisabled
  }
}
